import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const ABOUT_MAIN =
  "/img/product/1.jpeg";
const ABOUT_SUB1 =
  "https://images.unsplash.com/photo-1615485500834-bc10199bc727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxzcGljZXMlMjBmbGF0bGF5JTIwdHVybWVyaWMlMjBjaGlsaXxlbnwwfHx8fDE3ODE0MzY3NjV8MA&ixlib=rb-4.1.0&q=85";
const ABOUT_SUB2 =
  "https://images.unsplash.com/photo-1583394293214-28ded15ee548?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjaGVmJTIwa2l0Y2hlbiUyMGF1dGhlbnRpYyUyMGFzaWFufGVufDB8fHx8MTc4MTQzNjc2NXww&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { t } = useLang();

  return (
    <section
      id="about"
      className="relative bg-brand-cream-alt py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-5 md:sticky md:top-32 self-start"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-8 h-px bg-brand-red" />
              <span className="font-sans text-[11px] tracking-[0.3em] uppercase text-brand-red">
                {t.about.label}
              </span>
            </div>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-brand-ink leading-[0.95]">
              {t.about.headline}
              <br />
              <span className="italic text-brand-red">{t.about.headline2}</span>
            </h2>

            <div className="overflow-hidden rounded-sm mt-10 aspect-[4/5]">
              <motion.img
                whileInView={{ scale: 1 }}
                initial={{ scale: 1.1 }}
                transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                viewport={{ once: true }}
                src={ABOUT_MAIN}
                alt="Bandeng Primaroso heritage"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-7 md:pl-12 md:pt-24"
          >
            <p className="font-serif text-2xl md:text-3xl text-brand-ink leading-[1.4] italic">
              “{t.about.bodyA}”
            </p>
            <p className="font-sans text-base md:text-lg text-brand-muted leading-relaxed mt-8 max-w-xl">
              {t.about.bodyB}
            </p>

            <div className="mt-12 grid grid-cols-2 gap-px bg-brand-ink/10 border border-brand-ink/10">
              {t.about.meta.map((m, i) => (
                <div key={i} className="bg-brand-cream-alt p-6 md:p-8" data-testid={`about-stat-${i}`}>
                  <div className="font-serif text-3xl md:text-4xl text-brand-red">{m.k}</div>
                  <div className="font-sans text-xs tracking-[0.2em] uppercase text-brand-muted mt-2">
                    {m.v}
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 gap-4 md:gap-6 mt-12">
              <div className="overflow-hidden rounded-sm aspect-square md:translate-y-12">
                <img src={ABOUT_SUB1} alt="Spices" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="overflow-hidden rounded-sm aspect-square">
                <img src={ABOUT_SUB2} alt="Kitchen" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
